import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.uiActionRendering.DOC}
  mutation TestMosaicActionRendering(
    $tenantId: ID!
    $zoneId: ID!
    $actionRendering: AWSJSON!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          testActionRendering(actionRendering: $actionRendering) {
            ...FragmentMosaicUiActionRendering
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.TestMosaicActionRenderingMutation,
    readonly ents.core.mosaic.Action.Rendering.OfUiOperationsOnly[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'mosaicDev',
        graphql.transformers.OUT.select(
          'testActionRendering',
          graphql.transformers.OUT.list(
            fragments.uiActionRendering.TRANSFORMER,
            {
              onNullish: 'remove',
            },
          ),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.TestMosaicActionRenderingMutation,
  readonly ents.core.mosaic.Action.Rendering.OfUiOperationsOnly[],
  graphql.schema.TestMosaicActionRenderingMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
